// MARK: React
import * as React from "react";
import "./style.scss";

import { FormControl as MFormControl } from "@material-ui/core";
import { InputLabel as MInputLabel } from "@material-ui/core";
import { Select as MSelect } from "@material-ui/core";
import { OutlinedInput as MOutlinedInput } from "@material-ui/core";

interface IProps {
	title: string;
	values: string[];
	translatorValue: (value: string) => string;
	changeValue: (value: string) => void;
	selectedValue?: string | null;
	minWidth?: string;
}

export default class SelectOptions extends React.Component<IProps> {
	public render() {
		return (
			<div className="selectOptionsFormControl">
				<MFormControl  variant="outlined" style={{ width: "100%" }}>
					<MInputLabel
						htmlFor="outlined-age-native-simple"
						shrink={true}
					>
						{this.props.title}
					</MInputLabel>
					<MSelect
						native={true}
						onChange={(event) => this.props.changeValue(event.target.value as string)}
						input={
							<MOutlinedInput  name="age" labelWidth={120} id="outlined-age -native-simple" notched={true} />
						}
						style={{ width: "100%" }}
						className="selectOptionsSelect"
					>
						{
							this.props.values.map((value, index) => {
								return (
									// tslint:disable-next-line: react-a11y-role-has-required-aria-props
									<option
										value={value}
										key={value}
										selected={value === this.props.selectedValue}
									>
										{this.props.translatorValue(value)}
									</option>
								);
							})
						}
					</MSelect>
				</MFormControl>
			</div>
		);
	}
}
